import { ComparableProperty } from "../types";

export enum AddressPart {
  ADDRESS,
  CITY,
  STATE,
  ZIP,
  CITY_STATE_ZIP
}

export function getAddressPart(fullAddress: string, part: AddressPart): string | null {
  if (!fullAddress || typeof fullAddress !== 'string') {
    return null;
  }

  const parts = fullAddress.split(',').map(p => p.trim()).filter(Boolean);

  // Try to extract ZIP code (must be 5 digits at end)
  const zipMatch = fullAddress.match(/\b\d{5}\b$/);
  const zip = zipMatch ? zipMatch[0] : null;

  // Try to extract state (2-letter code before ZIP)
  const stateMatch = fullAddress.match(/\b([A-Za-z]{2})\b,?\s*\d{5}$/);
  const state = stateMatch ? stateMatch[1].toUpperCase() : null;

  // Address is usually the first part
  const address = parts[0] || null;

  // City is usually the second-to-last part before state and ZIP
  const city = parts.length >= 3 ? parts[parts.length - 3] : null;

  switch (part) {
    case AddressPart.ADDRESS:
      return address;
    case AddressPart.CITY:
      return city;
    case AddressPart.STATE:
      return state;
    case AddressPart.ZIP:
      return zip;
    case AddressPart.CITY_STATE_ZIP:
      return [city, state, zip].filter(Boolean).join(', ') || null;
    default:
      return null;
  }
}

export const getRecommendedPropertyImage = (property: ComparableProperty) => {
  const images = property?.data?.images;
  if (!images || images.length === 0) return null;
  const recommendedImage = images.find(image => image.recommended_preview);
  const image = recommendedImage || images[0];
  return image || null;
}